import React from 'react';
import * as PropTypes from 'prop-types';
import {
  Col, Icon, Row, Typography,
} from 'antd';
import '../../../../components/panels/Panels.css';
import { FormattedMessage } from 'react-intl';

const { Title, Text } = Typography;

/**
 * Bynx Panel - Detail (a panel with a title and padding around the contents
 *                      with options for header buttons etc)
 * @param titleId     heading text translation ID
 * @param level       heading title level (1-4)
 * @param parameters  elements for shoing or choosing data parameters (optional)
 * @param actions     elements for page actions/buttons (optional)
 * @param children    contents of the panel
 * @returns {*}
 * @constructor
 */
export default function ConfigHeading({
  titleId, descriptionId, parameters, actions, children, links, border, title,
}) {
  return (
    <div className="via-panel-layout" style={{ border }}>
      <div className="via-panel-header">
        <Row align="top" justify="start" type="flex">
          <Title level={3}>{!title ? <FormattedMessage id={titleId} /> : title}</Title>
        </Row>
        <Row align="top" justify="space-between" type="flex">
          <Row>
            <Text>{descriptionId !== '' ? <FormattedMessage id={descriptionId} /> : ''}</Text>
            { links
              ? (
                <Row style={{ display: 'block', marginTop: '0.5em', marginBottom: '1em' }}>
                  { links.map(link => (
                    <Row key={Math.random()}>
                      <Col>
                        <Icon type="arrow-right" style={{ fontSize: '8pt', marginLeft: '0.2em', color: 'var(--component-primary-colour)' }} />
                    &nbsp;
                        { link }
                      </Col>
                    </Row>
                  ))}
                </Row>
              )
              : '' }
            <Row className="via-panel-detail-params">
              {parameters}
            </Row>
          </Row>
          <Row className="via-panel-detail-actions" type="flex" justify="end">
            {actions}
          </Row>
        </Row>
      </div>
      <Row>
        {children}
      </Row>
    </div>
  );
}

// Validate the prop type parameters.
ConfigHeading.propTypes = {
  titleId: PropTypes.string.isRequired,
  descriptionId: PropTypes.string,
  border: PropTypes.string,
  parameters: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element), PropTypes.string]),
  actions: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element), PropTypes.string]),
  links: PropTypes.arrayOf(PropTypes.element),
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)]))]).isRequired,
};

ConfigHeading.defaultProps = {
  descriptionId: '',
  parameters: null,
  actions: null,
  links: null,
  border: '',
  title: null,
};
